import Head from 'next/head'
import MyAccounts from '@/features/myAccounts'
import { BRAND_NAME } from '@/config/constants'
import { type ReactElement } from 'react'
import { type Router } from 'next/router'
import { EvmLayout, type NextPageWithLayout } from '../../_app'

const Accounts: NextPageWithLayout = () => {
  return (
    <>
      <Head>
        <title>{`${BRAND_NAME} – My accounts`}</title>
      </Head>

      <MyAccounts />
    </>
  )
}

export default Accounts

Accounts.getLayout = function getLayout(page: ReactElement, router: Router) {
  return <EvmLayout router={router}>{page}</EvmLayout>
}
